module.exports = __webpack_public_path__ + "img/70d77f8.png";